









































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import { DxTabs } from 'devextreme-vue';
import { ProgressStatementsClient, ProgressStatement, UpdateProgressStatementCommand, ProgressStatementBlock, ProgressStatementDto } from '@/data/web-api-client';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import ProgressStatementDocument from '@/modules/progressStatements/components/ProgressStatementDocument.vue';
import ProgressStatementDetailsCard from '@/modules/progressStatements/components/ProgressStatementDetailsCard.vue';
import ProgressStatementBlockCard from '@/modules/progressStatements/components/ProgressStatementBlockCard.vue';
import ProgressStatementsArticleSummaryTable from '@/modules/progressStatements/components/ProgressStatementsArticleSummaryTable.vue';
import ProgressStatementAddDataDialog from '@/modules/progressStatements/components/ProgressStatementAddDataDialog.vue';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    Card,
    DxTabs,
    EventLogsTable,
    ProgressStatementDocument,
    ProgressStatementDetailsCard,
    ProgressStatementBlockCard,
    ProgressStatementsArticleSummaryTable,
    ProgressStatementAddDataDialog,
  },
})
export default class ProgressStatementDetailPage extends Vue {
  loading: boolean = true;
  initialised: boolean = false;
  saving: boolean = false;
  dirty: boolean = false;
  navIndex: number = 0;
  progressStatement: ProgressStatementDto = new ProgressStatement();
  client: ProgressStatementsClient = new ProgressStatementsClient(undefined, this.$axios);
  leftPositionBottomBar: number = 0; // For bottom bar
  disabled = false;

  versionNumber: number = 1;

  created() {
    this.loadData();
  }

  mounted() {
    if (document) {
      const bar = document.getElementById('savebar');

      if (bar) {
        const rect = bar.getBoundingClientRect();
        this.leftPositionBottomBar -= rect.left;
      }
    }
  }

  addData() {
    (this.$refs.ProgressStatementAddDataDialog as ProgressStatementAddDataDialog).open();
  }

  async loadData() {
    try {
      this.loading = true;
      this.progressStatement = await this.client.getSingle(this.documentNumber.replaceAll('/', '-'));
      this.versionNumber = this.progressStatement.versionNumber ?? 1;

      this.disabled = this.progressStatement.projectIsOnHold!;
      setTimeout(() => {
        this.initialised = true;
      }, 500);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  removeBlock(index: number) {
    this.progressStatement.blocks!.splice(index, 1);
  }

  createBlock() {
    if (!this.progressStatement) {
      throw Error('progressStatement is null');
    }
    const name = prompt('Geef de naam van de nieuwe blok op', '');
    if (name && name !== '') {
      this.progressStatement.blocks!.push(
        new ProgressStatementBlock({
          title: name,
          lines: [],
          total: 0,
          totalCost: 0,
          totalMargin: 0,
        })
      );
    }
  }

  async save() {
    const documentNumberCopy = `${this.documentNumber}`.replaceAll('/', '-');

    try {
      this.saving = true;

      const command = new UpdateProgressStatementCommand(this.progressStatement);
      await this.client.update(documentNumberCopy, command);
      (this.$refs.ProgressStatementAddDataDialog as ProgressStatementAddDataDialog).loadData();
      this.dirty = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  increaseVersionNumber() {
    this.versionNumber++;
    this.progressStatement.versionNumber = this.progressStatementVersion;
  }

  get title() {
    return `Vorderingstaat ${this.progressStatement.documentNumber}-${this.progressStatementVersion}`;
  }

  get progressStatementVersion() {
    return this.versionNumber;
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Basis' },
      { icon: 'fas fa-info-circle', text: 'Samenvatting' },
      { icon: 'fas fa-file-pdf', text: 'Document' },
      { icon: 'fas fa-history', text: 'Geschiedenis' },
    ];
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectName: this.documentNumber,
      type: EventLogsObjectType.ProgressStatement,
    };
  }

  get documentNumber() {
    return this.$route.params.documentNumber.replaceAll('-', '/');
  }

  get codeSummary() {
    const result: Array<{
      articleId: string;
      quantity: number;
      unitPrice: number;
    }> = [];

    if (!this.progressStatement.blocks) {
      return result;
    }

    this.progressStatement.blocks.forEach((block) => {
      if (block.lines) {
        block.lines.forEach((line) => {
          if (line.articleId && line.articleId !== '' && line.quantity && line.total) {
            const resultIndex = result.findIndex((o) => o.articleId === line.articleId);
            if (resultIndex === -1) {
              result.push({
                articleId: line.articleId,
                quantity: line.quantity,
                unitPrice: line.total,
              });
            } else {
              result[resultIndex].quantity += line.quantity;
              result[resultIndex].unitPrice += line.total;
            }
          }
        });
      }
    });

    result.forEach((resultItem) => {
      resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
    });

    return result;
  }

  @Watch('progressStatement', { deep: true })
  onProgressStatementChanged() {
    if (this.initialised) {
      this.versionNumber = this.progressStatement.versionNumber ?? 1;
      this.dirty = true;
    }
  }
}
